import styled from "@emotion/styled";

export const Text = styled.span`
  i {
    font-weight: 400;
    font-style: italic;
  }
`;
